import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import PropTypes from 'prop-types'
import EditIcon from '@components/Icon/Edit'
import AddIcon from '@components/Icon/Add'
import DeleteIcon from '@components/Icon/Delete'
import { epdRejectionReasonApi } from '@atheneum/api'
import { showDialog, isCancellationError } from '@components/Dialog'

class EpdRejectionReasonTable extends Component {
  static propTypes = {
    modalStore: PropTypes.object,
    epdRejectionReasonStore: PropTypes.object,
    growlStore: PropTypes.object
  }

  handleDeletion = epdRejectionReason => {
    const { growlStore, epdRejectionReasonStore } = this.props

    return showDialog({
      title: 'Delete EPD rejection reason?',
      text: `Are you sure you want to delete ${epdRejectionReason.name}?`,
      type: 'info',
      showCancelButton: true,
      confirmButtonText: 'Yes'
    })
      .then(async () => {
        await epdRejectionReasonApi.deleteOne(epdRejectionReason.id)
        epdRejectionReasonStore.getEpdRejectionReasons()
        growlStore.showSuccess(
          `EPD rejection reason ${epdRejectionReason.name} deleted`
        )
      })
      .catch(error => {
        if (isCancellationError(error)) return
        growlStore.showError(error)
      })
  }

  renderRows = () => {
    const { epdRejectionReasonStore, modalStore } = this.props
    const { epdRejectionReasons } = epdRejectionReasonStore
    const epdRejectionReasonRows = epdRejectionReasons.map(
      epdRejectionReason => {
        return (
          <tr key={epdRejectionReason.id}>
            <td>{epdRejectionReason.name}</td>
            <td className='right'>
              <EditIcon
                className='clickable'
                onClick={() => {
                  modalStore.show({
                    type: 'EPD_REJECTION_REASON_FORM',
                    props: {
                      epdRejectionReasonStore,
                      epdRejectionReason,
                      wideContent: true
                    }
                  })
                }}
              />
              <DeleteIcon
                className='clickable'
                onClick={() => this.handleDeletion(epdRejectionReason)}
              />
            </td>
          </tr>
        )
      }
    )

    return <tbody>{epdRejectionReasonRows}</tbody>
  }

  renderNewRow = () => {
    const { modalStore, epdRejectionReasonStore } = this.props

    return (
      <tr>
        <td />
        <td
          className='right clickable'
          onClick={() => {
            modalStore.show({
              type: 'EPD_REJECTION_REASON_FORM',
              props: {
                epdRejectionReasonStore,
                wideContent: true
              }
            })
          }}
        >
          <AddIcon />
        </td>
      </tr>
    )
  }

  render () {
    return (
      <table className='table-wrapper'>
        <thead>
          <tr>
            <th>Name</th>
            <th className='right'>Actions</th>
            <th className='half-width' />
          </tr>
        </thead>
        {this.renderRows()}
        {this.renderNewRow()}
      </table>
    )
  }
}

export default inject(
  'modalStore',
  'growlStore'
)(observer(EpdRejectionReasonTable))
